<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <template v-for="orderProduct in orderProducts">
              <div class="row">
                <div class="col-6">
                  {{ orderProduct.description }}
                </div>
                <div class="col">
                  {{ orderProduct.price | decimal }} X
                  {{ orderProduct.quantity | decimal }}UN
                </div>
                <div class="col text-right">
                  {{ getSubTotal(orderProduct) | decimal }}
                </div>
              </div>
              <hr />
            </template>
          </div>
        </div>
        <div
          style="display: flex; align-items: end;  justify-content: end; "
          class="row"
        >
          <div class="col-4">
            <number-input
              :alias="'Desconto(R$)'"
              :minimumValue="-999999999"
              @input="addDiscount($event)"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-right">
            <button
              class="btn btn-success btn-block mt-3"
              @click="handleFinishOrder()"
            >
              <div class="d-flex justify-content-between w-100">
                <div>Finalizar Venda (F12)</div>
                <div>
                  <b>{{ netTotal | decimal }}</b>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    orderProducts() {
      return this.$store.state.orderForm.order.order_products;
    },

    netTotal() {
      return this.$store.getters["orderForm/netTotal"];
    }
  },

  methods: {
    handleFinishOrder() {
      this.$emit("finishOrder");
    },

    getSubTotal(orderProduct) {
      return orderProduct.quantity * orderProduct.price;
    },
    addDiscount(value) {
      this.$store.commit("orderForm/addDiscount", value);
    }
  }
};
</script>

<style></style>
